<template>
  <KButton
    :disabled="isDisabled"
    :qa-id="`${qaId}_button`"
    :data-testid="`${dataTestid}_button`"
    :theme-color="themeColor"
    :fill-mode="fillMode"
    @click="$emit(this.action, $event)"
  >
    <FontAwesomeIcon
      v-if="hasIconBeforeLabel"
      :name="iconBefore.name"
      :type="iconBefore.type"
      :size="iconBefore.size"
      :fw="iconBefore.fw"
      :style="iconBefore.style"
      :class="`${iconBefore.class} pr-1` "
      :qa-id="`${qaId}_icon_before`"
      :data-testid="`${dataTestid}_icon_before`"
    />
    <span
      v-if="hasButtonLabel"
      class="zo-button--label"
      :qa-id="`${qaId}_label`"
      :data-testid="`${dataTestid}_label`"
    >
      {{ buttonLabel }}
    </span>
    <FontAwesomeIcon
      v-if="hasIconAfterLabel"
      :name="iconAfter.name"
      :type="iconAfter.type"
      :size="iconAfter.size"
      :fw="iconAfter.fw"
      :style="iconAfter.style"
      :class="`${iconAfter.class} pl-1`"
      :qa-id="`${qaId}_icon_after`"
      :data-testid="`${dataTestid}_icon_after`"
    />
  </KButton>
</template>

<script>
import { Button as KButton } from '@progress/kendo-vue-buttons';

import FontAwesomeIcon from '@/components/elements/FontAwesomeIcon.vue';

export default {
  components: {
    FontAwesomeIcon,
    KButton,
  },

  props: {
    disabled: Boolean,
    label: {
      type: [String, Number],
      default: '',
    },
    fillMode: {
      type: String,
      default: 'solid',
    },
    action: {
      type: String,
      default: 'clicked',
    },
    size: {
      type: String,
      default: '',
    },
    qaId: {
      type: String,
      default: '',
    },
    dataTestid: {
      type: String,
      default: '',
    },
    // @todo CLEANUP - Remove redundant attrs property.
    attrs: {
      type: Object,
      default: () => ({}),
    },
    iconBefore: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
    iconAfter: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
    themeColor: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    buttonLabel() {
      return this.label;
    },
    hasButtonLabel() {
      return !!this.label;
    },
    hasIconBeforeLabel() {
      return !!this.iconBefore.name;
    },
    hasIconAfterLabel() {
      return !!this.iconAfter.name;
    },
    isDisabled() {
      // Determine if disabled property was explicitly passed or passed via attrs.
      return !!(this.disabled || this.attrs.disabled);
    },
  },
};
</script>

<style lang="scss">
  // .zo-button {
  //   --button-fg: var(--text-dark);
  //   --button-bg1: var(--gray-lighten-4);
  //   --button-bg2: var(--gray-lighten-3);
  // --icon-color: var(--button-fg);

  //   --button-ledge: 0 0 0 0;
  //   --button-ledge-color: rgba(var(--black-rgb), .2);
  //   --button-border-color: rgba(var(--black-rgb), .5);
  //   --button-border-radius: var(--radius-default);
  //   --button-font-size: inherit;
  //   --button-border-width: .05em;
  //   --button-border-style: solid;
  //   --button-border: var(--button-border-width) var(--button-border-style) var(--button-border-color);
  //   --button-bg: var(--button-bg1) linear-gradient(to bottom, var(--button-bg1), var(--button-bg2));
  //   --button-shadow: var(--button-ledge) var(--button-ledge-color) inset;

  //   display: inline-flex;
  //   justify-content: var(--button-text-align, center);
  //   align-items: center;
  //   font-size: var(--button-font-size);
  //   font-family: var(--button-font-family, var(--font-button));
  //   margin: var(--button-margin,
  //       var(--button-margin-top, 0)
  //       var(--button-margin-right, 0)
  //       var(--button-margin-bottom, 0)
  //       var(--button-margin-left, 0)
  //     );
  //   padding: var(--button-padding, 0 .5em);
  //   border: var(--button-border);
  //   border-radius: var(--button-border-radius);
  //   line-height: var(--button-line-height, 2);
  //   color: var(--button-fg);
  //   background: var(--button-bg);
  //   box-shadow: var(--button-shadow);
  //   cursor: pointer;

  //   + .zo-button {
  //     --button-margin-left: var(--space-default);
  //   }

  //   > * + * {
  //     margin-left: var(--space-min);
  //   }

  //   &[disabled] {
  //     opacity: .4;
  //     cursor: not-allowed;
  //   }

  //   &:not([disabled]) {
  //     &:hover,
  //     &:focus {
  //       --button-ledge: var(--local-button-ledge, 0 -.15em 0 0);
  //     }

  //     &:focus {
  //       --button-shadow:
  //         var(--button-ledge) var(--button-ledge-color) inset,
  //         var(--focus-outline-shadow);
  //       outline: var(--focus-outline);
  //       outline-offset: var(--focus-outline-offset);
  //     }

  //     &:active {
  //       --button-bg1: var(--gray-lighten-3);
  //       --button-bg2: var(--gray-lighten-4);
  //       --button-ledge: var(--local-button-ledge, 0 .1em 0 0);
  //       --button-ledge-color: rgba(var(--white-rgb), .3);
  //     }
  //   }

  //   &--label {
  //     white-space: nowrap;
  //   }

  //   &--small {
  //     --button-font-size: var(--text-size-small);
  //   }

  //   &--medium {
  //     --button-font-size: var(--text-size-medium);
  //   }

  //   &--large {
  //     --button-font-size: var(--text-size-large);
  //   }

  //   &--slim {
  //     --button-line-height: 1.6;
  //   }

  //   &--primary {
  //     --button-fg: var(--white);
  //     --button-bg1: var(--brand-lighten-1);
  //     --button-bg2: var(--brand-base);

  //     &:not([disabled]):active {
  //       --button-bg1: var(--brand-base);
  //       --button-bg2: var(--brand-lighten-1);
  //     }
  //   }

  //   &--link {
  //     --button-font-family: var(--font-icon);
  //     --button-fg: var(--text-link);
  //     --button-bg1: none;
  //     --button-bg2: none;
  //     --button-padding: 0;
  //     --button-margin: 0;
  //     --button-border: none;
  //     --button-line-height: 1.5;

  //     &:not([disabled]) {
  //       &:hover,
  //       &:focus {
  //         --button-ledge: 0 0 0 0;
  //         --focus-outline: none;
  //         --focus-outline-shadow: none;
  //         --button-fg: var(--focus-color);
  //       }

  //       &:active {
  //         --button-bg1: none;
  //         --button-bg2: none;
  //         --button-fg: var(--text-link);
  //       }
  //     }
  //   }

  //   &--action {
  //     --button-font-family: var(--font-icon);
  //     --button-fg: var(--text-link);
  //     --button-bg1: none;
  //     --button-bg2: none;
  //     --button-padding: 0;
  //     --button-margin: 0;
  //     --button-border: none;
  //     --button-line-height: 1.5;

  //     &:not([disabled]) {
  //       &:hover,
  //       &:focus {
  //         --button-shadow: none;
  //       }

  //       &:active {
  //         --button-bg1: none;
  //         --button-bg2: none;
  //         --button-fg: var(--text-link);
  //       }
  //     }
  //   }

  //   &--simple {
  //     --button-font-family: var(--font-icon);
  //     --button-border-color: var(--simple-button-border-color, var(--brand-base));
  //     --button-bg: var(--simple-button-bg, var(--gray-lighten-5));
  //     --button-fg: var(--simple-button-fg, var(--brand-base));
  //     --button-text-align: var(--local-button-text-align, inherit);

  //     &:not([disabled]) {
  //       &:hover,
  //       &:focus {
  //         --button-ledge: 0 0 0 0;
  //         --button-shadow: var(--focus-outline-shadow);
  //         --button-fg: var(--simple-button-focus-color, var(--focus-color));

  //         outline: none;
  //       }
  //     }

  //     &:active {
  //       transform: scale(.98);
  //     }
  //   }

  //   &--note {
  //     @extend .zo-button--simple;
  //   }

  //   &--sweet {
  //     --button-font-family: var(--font-icon);
  //     --button-border-color: var(--sweet-button-border-color, transparent);
  //     --button-bg: var(--sweet-button-bg, var(--brand-lighten-2));
  //     --button-fg: var(--sweet-button-fg, var(--white));
  //     // --button-margin: 0;

  //     text-align: inherit;
  //     font-weight: bold;

  //     &:not([disabled]) {
  //       &:hover,
  //       &:focus {
  //         --button-ledge: 0 0 0 0;
  //         --button-shadow: 0 0 0 .1em var(--white) inset, 0 0 0 .1em var(--brand-base);
  //         --button-fg: var(--sweet-button-focus-color, var(--white));
  //         --focus-outline: none;
  //       }
  //     }

  //     &:active {
  //       transform: scale(.98);
  //     }
  //   }

  //   &--unbutton {
  //     --button-bg: none;
  //     --button-fg: inherit;
  //     --button-border-width: 0;
  //     --button-line-height: 1.2;
  //     --button-margin: 0;

  //     font-family: inherit;
  //     padding: 0;
  //     text-align: inherit;

  //     &:not([disabled]) {
  //       &:hover,
  //       &:focus {
  //         --button-ledge: 0 0 0 0;
  //         --focus-outline: none;
  //         --focus-outline-shadow: none;
  //       }
  //     }
  //   }

  //   &--icon {
  //     --button-padding: 0;
  //     --button-border-color: transparent;
  //     --button-border-radius: var(--radius-full-circle);
  //     --button-bg: none;
  //     --button-fg: inherit;
  //     --button-shadow: none;

  //     height: var(--button-size, var(--space-bump));
  //     width: var(--button-size, var(--space-bump));
  //     line-height: 1;
  //     opacity: var(--button-opacity, .6);
  //     cursor: pointer;
  //     display: inline-flex;
  //     align-items: center;
  //     justify-content: center;
  //     transition: 100ms;

  //     &:hover,
  //     &:focus {
  //       --button-shadow: var(--focus-outline-shadow);
  //       --button-fg: var(--focus-color);

  //       outline: none;
  //     }
  //   }
  // }

  // .zo-button--list {
  //   .zo-button {
  //     --button-font-family: var(--font-icon);
  //     --button-border-color: transparent;
  //     --button-bg: var(--gray-lighten-5);
  //     --button-fg: var(--aqua-darken-1);
  //     --button-margin: 0;

  //     display: flex;
  //     width: 100%;

  //     &:hover,
  //     &:focus {
  //       --button-shadow: var(--focus-outline-shadow);
  //       --button-fg: var(--focus-color);

  //       outline: none;
  //     }

  //     &:active {
  //       transform: scale(.98);
  //     }
  //   }
  // }

  // * + .zo-button {
  //   --button-margin-left: var(--space-default);
  // }
</style>
